// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vocal-remover-advantages_wrapper__XnsdO","title":"vocal-remover-advantages_title__cv8v5","advantages_wrapper":"vocal-remover-advantages_advantages_wrapper__HgqP_"};